var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-slot-banner banner banner-html5",attrs:{"id":_vm.id}},[_c('div',[(_vm.source)?_c('iframe',{attrs:{"scrolling":"no","marginwidth":"0","marginheight":"0","width":_vm.resource.width(),"height":_vm.resource.height(),"border":"0","frameborder":"0","src":_vm.source}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }